var _path;
import * as React from "react";
var SvgPaginationNext = function SvgPaginationNext(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.613856,11.3948 9.2188563,11.395 11.61574,8.9979167 H 0.99114395 V 7.0020833 H 11.61554 L 9.2188563,4.6056658 11.613856,4.605 l 3.395,3.3953329 z"
  }));
};
export default SvgPaginationNext;